import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { CircularProgress } from '@material-ui/core';

// components
import Layout from "./Layout";

// pages
import Login from "../pages/login";

// provider
import { useUser } from "../providers/App/User/UserProvider";

// utilities
import iff from "../utils/iff";

const App = ()  => {
  // global
  const { authenticationState } = useUser();
  React.useEffect(() => {

  })
  return (
    <BrowserRouter>
      {
        iff(
          authenticationState.isLoading,
          <Route path="/" render={
            () => <div className="position-absolute top-50 left-50 translate--minus-50">
                    <CircularProgress />
                  </div>
          } />,
          authenticationState.isAuthenticated
          ?
          <Switch>
            <Route exact path="/" render={()=><Redirect to="/app/cancellations/view" />}  />
            <Route path="/app" render={(props) => React.createElement(Layout, props)} />
          </Switch>
          :
          <Route path="/" component={Login} />
        )
      }
    </BrowserRouter>
  );
}

export default App;
